/**
 * Blueprint Product Page Scripts
 * 
 * Functionality:
 * - Smooth scroll for anchor links
 * - FAQ accordion
 * - Phase accordion (mobile)
 * - Mobile sticky CTA visibility
 */

(function() {
  'use strict';

  /**
   * Initialize all functionality when DOM is ready
   */
  function init() {
    initSmoothScroll();
    initAccordions();
    initMobileStickyScroll();
  }

  /**
   * Smooth scroll for anchor links
   */
  function initSmoothScroll() {
    const smoothScrollLinks = document.querySelectorAll('.js-smooth-scroll, a[href^="#"]');
    
    smoothScrollLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // Only handle internal anchor links
        if (href && href.startsWith('#') && href.length > 1) {
          const target = document.querySelector(href);
          
          if (target) {
            e.preventDefault();
            
            // Calculate offset for any fixed headers
            const headerOffset = 80;
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Update URL without scrolling
            history.pushState(null, null, href);
          }
        }
      });
    });
  }

  /**
   * Initialize all accordion functionality
   * Works for both FAQ and Phase accordions
   */
  function initAccordions() {
    // FAQ Accordions
    const faqTriggers = document.querySelectorAll('.bp-faq-trigger');
    faqTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        toggleAccordion(this, '.bp-faq-content');
      });
      
      // Keyboard support
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(this, '.bp-faq-content');
        }
      });
    });
    
    // Phase Accordions (mobile)
    const phaseTriggers = document.querySelectorAll('.bp-accordion-trigger');
    phaseTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        toggleAccordion(this, '.bp-accordion-content');
      });
      
      // Keyboard support
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(this, '.bp-accordion-content');
        }
      });
    });
  }

  /**
   * Toggle accordion open/close
   * @param {HTMLElement} trigger - The button that was clicked
   * @param {string} contentSelector - CSS selector for content element
   */
  function toggleAccordion(trigger, contentSelector) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    
    if (!content) return;
    
    if (isExpanded) {
      // Close
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = '0';
    } else {
      // Open
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  /**
   * Mobile sticky CTA - show/hide based on scroll position
   */
  function initMobileStickyScroll() {
    const stickyEl = document.querySelector('.bp-mobile-sticky');
    const heroSection = document.querySelector('.bp-hero');
    
    if (!stickyEl || !heroSection) return;
    
    // Throttle scroll events for performance
    let ticking = false;
    
    function updateStickyVisibility() {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const pricingSection = document.getElementById('pricing');
      
      // Show sticky if scrolled past hero
      if (heroBottom < 0) {
        stickyEl.classList.add('bp-mobile-sticky--visible');
      } else {
        stickyEl.classList.remove('bp-mobile-sticky--visible');
      }
      
      // Optional: Hide when pricing section is in view
      if (pricingSection) {
        const pricingTop = pricingSection.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        
        if (pricingTop < viewportHeight * 0.5) {
          stickyEl.classList.remove('bp-mobile-sticky--visible');
        }
      }
      
      ticking = false;
    }
    
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyVisibility);
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Initial check
    updateStickyVisibility();
  }

  /**
   * Run init when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
